import React, { useState } from "react";
import moment from "moment";

const getMomentFromComponents = (datePart, timePart) => {
  const startDate = moment.utc(datePart).format("YYYY-MM-DD ") + timePart;
  return moment.utc(startDate, "YYYY-MM-DD HH:mm");
}

const AircraftScheduledMaintenanceValidator = (props) => {
  const record = props.data.record;

  const [state, setState] = useState({
    error: null,
    errorMessage: null
  }); 

  let error = false;
  let errorMessage = "";

  /*
    Examples of validators - the record will have a copy of the working data
  */
  // if (!record.*code*) { 
  //   error = true;
  //   errorMessage = "Please select a valid code";
  // } else if (!moment(record.*date*).isValid()) {
  //   error = true;
  //   errorMessage = "Please enter a valid date";
  // } else if (moment(record.*date1*).isBefore(record.*date2*)) {
  //   error = true;
  //   errorMessage = "The '*date1 name*' date cannot be before the '*date2 name' date";
  // } else if (record.*number* <= 0) {
  //   error = true;
  //   errorMessage = "The *number field* must be greater than zero";
  // }   


  if (!error && !record.aircraftCheck) {
    error = true;
    errorMessage = "'Check / AOG' is required";
  }
  if (!error && !moment(record.startCheckDate).isValid()) {
    error = true;
    errorMessage = "'Scheduled Start' does not contain a valid date";
  }
  if (!error && !record.startTime) {
    error = true;
    errorMessage = "'Start Time' is required";
  }
  if (!error && !moment(record.endCheckDate).isValid()) {
    error = true;
    errorMessage = "'Scheduled End' does not contain a valid date";
  }
  if (!error && record.aircraftCheck !== "AOG" && !record.endTime) {
    error = true;
    errorMessage = "'End Time' is required";
  }
  if (!error) {
    const startMoment = getMomentFromComponents(record.startCheckDate, record.startTime);
    const endMoment = getMomentFromComponents(record.endCheckDate, record.endTime);
    if (endMoment.isBefore(startMoment)) {
      error = true;
      errorMessage = "'End Time' must be after 'Start Time'";
    }
  }
  if (!error) {
    const startMoment = getMomentFromComponents(record.startCheckDate, record.startTime);
    const endMoment = getMomentFromComponents(record.endCheckDate, record.endTime);
    if (endMoment.diff(startMoment,'hour')<1 && record.aircraftCheck !== "AOG") {
      error = true;
      errorMessage = "Verify the check duration, must exceed 1 hour";
    }
  }
  if (!error && !record.mxAirportCode) {
    error = true;
    errorMessage = "'At Airport' is required";
  }
  if (!error && !record.status) {
    error = true;
    errorMessage = "'Status' is required";
  }

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage });
    if (props.onChange) {        
      props.onChange({ error, errorMessage });
    }
  }

  return (
    <div style={{display:"none"}}>
      {state.errorMessage}
    </div>
  );
}

export default AircraftScheduledMaintenanceValidator;
